import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { AuthenticationService } from '@app/services/authentication.service';
import { NeoTableService } from '../components/neo-table/neo-table.service';

@Pipe({
    name: 'neoDate',
    standalone: false
})
export class NeoDatePipe implements PipeTransform {
  constructor(private authService: AuthenticationService) { }
  /* This pipe converts the input date value using any Angular-compatible date format string,
     applying the user's locale and timezone automatically.
     Input  -> (value: date|string, format?: string) -> "2022-10-17T05:57:07.8619924", "dd MMM yyyy"
     Output -> (string) -> "17 Oct 2022"
     Supports all Angular date pipe formats: named presets ('short', 'mediumDate', 'longDate', etc.)
     and custom tokens ('dd/MM/yyyy', 'MMM d, y', 'EEEE', etc.) */
  transform(value?: Date | string, format: string = 'mediumDate'): string {
    if (!value) return '';
    const userTimezone = this.authService.getActiveUser()?.extensionTimezoneId || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const locale = navigator.language;
    const isoDateStr = NeoTableService.getISODatetimeString(value);
    return formatDate(isoDateStr, format, locale, userTimezone);
  }
}
